var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCabilogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "166.6 223.2 244.3 247.9",
    enableBackground: "new 166.6 223.2 244.3 247.9",
    xmlSpace: "preserve",
    fill: "#352C2C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 400.3,
    cy: 272.5,
    r: 10.6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.7,469.1 400.3,469.1 407.8,469.1 407.8,321.8 392.7,321.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,317c-10.4,0-16.1,6-18.5,11.7V223.2h-15.1v245.9h7.6l2.3-3.3c5.3,3.6,12.6,5.2,21.7,5.2c20.4,0,30.6-9.7,30.6-28.7 c0-94.6,0-1.1,0-92.1C378.2,327.1,367.6,317,349.6,317z M331.1,350.2c-0.2-22.6,7.1-27.4,16.1-27.4c12.7,0,15.9,8.7,16,27.4 c0,92.2,0-3.2,0,91.6c0,17-3.9,24.3-15.6,24.3c-12.6,0-16.5-7.3-16.5-24.3V350.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.7,441.8c0,17-3.9,24.3-16.5,24.3c-11.7,0-15.6-7.3-15.6-24.3c0-45.7,0-48,0-48.1v0c0-0.1,0-2.4,0-48.1 c0-17,4.4-23.8,17-23.8s15.1,7.8,15.1,24.8c0,4,0,0.6,0,5.4h15.1c0-6.5,0-3.6,0-7.3c0-19-9.7-27.7-30.2-27.7 c-20.4,0-32.1,7.8-32.1,26.8c0,96.8,0,1.8,0,98.6c0,19,10.2,28.7,30.6,28.7c20.4,0,31.6-8.3,31.6-27.2c0-20.9,0-36.5,0-36.5h-15.1 C213.7,407.3,213.7,421.9,213.7,441.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.6,317c-20.4,0-30.2,8.8-30.2,27.7c0,3.7,0,0.9,0,7.3h15.1c0-4.8,0-1.4,0-5.4c0-17,2.4-24.8,15.1-24.8 c12.6,0,17,6.8,17,23.6h0l0,10.6l0-0.1c0.5,10.3-8.3,14.1-19.5,18.8c-8,3.4-16.1,6.4-21.5,12c-4,3.4-6.1,6.3-6.2,16.7 c0,9.6,0,28,0,38.8c0,19,10.2,28.7,30.6,28.7c9.2,0,16.5-1.7,21.7-5.2l2.3,3.3h7.6c0,0,0-108.6,0-123.6c0-0.6,0-1.2,0-1.8 C301.7,324.8,290,317,269.6,317z M286.6,441.8c0,17-3.9,24.3-16.5,24.3c-11.7,0-15.6-7.3-15.6-24.3c0-41.8,0-35.8,0-41.7 c0.9-10.1,4.5-14.6,13.8-19.6c9.8-5.3,15-7.7,18.4-12.6L286.6,441.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabilogoWhite);
export default __webpack_public_path__ + "static/media/cabilogo-white.c7cf57120e4c8996a4acef298afa853c.svg";
export { ForwardRef as ReactComponent };